import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
// import { ReceiptComponent } from '../receipt/receipt.component';
import { query } from '@angular/animations';
// import { ReceiptDetailComponent } from '../receipt-detail/receipt-detail.component';
import { TranslateService } from '@ngx-translate/core';
import { v } from '@angular/core/src/render3';

@Component({
  selector: 'app-receipt-list',
  templateUrl: './receipt-list.component.html',
  styleUrls: ['./receipt-list.component.css']
})
export class ReceiptListComponent implements OnInit {

  public menu_item_id = '24';
  public sample_menu_item_id = '98';
  public receipt_menu_item_id = '99';

  public sample_add_auth;
  public receipt_add_auth;
  public edit_auth;
  public del_auth;

  private dp = [];
  total1 = 0;
  total2 = 0;
  total3 = 0;

  receiptList = [{ 'receipt_name_ar': 'الكل', 'receipt_name_en': 'All', 'receipt_type': 'all' },
    { 'receipt_name_ar': 'قبض', 'receipt_name_en': 'Receipt', 'receipt_type': 'cash_receipt' },
    { 'receipt_name_ar': 'صرف', 'receipt_name_en': 'Voucher', 'receipt_type': 'payment_voucher' }];

  payMethodList = [{ 'payment_method_ar': 'الكل', 'payment_method_en': 'All', 'payment_method': 'all' },
    { 'payment_method_ar': 'نقدي', 'payment_method_en': 'Cash', 'payment_method': 'cash' },
    { 'payment_method_ar': 'بنك', 'payment_method_en': 'Bank', 'payment_method': 'bank' },
    { 'payment_method_ar': 'بطاقة ائتمانية', 'payment_method_en': 'Visa', 'payment_method': 'visa' }]

  displayedColumns = ['receipt_no', 'rec_no', 'receipt_type_name', 'date', 'acct_name',
    'paid', 'payment_method', 'comment', 'branch_name', 'created_by', 'detail', 'print', 'edit', 'del'];
  displayedColumns2 = ['receipt_no', 'rec_no', 'receipt_type_name', 'date', 'acct_name',
    'paid', 'payment_method', 'comment', 'branch_name', 'created_by'];
  dataSource = new MatTableDataSource(this.dp);
  // addDialogRef: MatDialogRef<ReceiptComponent>;
  // detailDialogRef: MatDialogRef<ReceiptDetailComponent>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': '', 'receipt_type': 'all', 'from_date': new Date(), 'to_date': new Date(),
    'branch_id': '0', 'title': 'السندات', 'rec_no': '', 'payment_method': 'all', 'user_name': 'all'
  };

  branchList = [];
  users = [];

  Success_Msg; Error_Msg; Del_Msg; Receipt_Type; Cash_Receipt; All;
  From_Date; To_Date; Receipt_List; Payment_Voucher; Cash; Bank; Visa;
  Search_Msg; Total_Cash_Receipt; Total_Payment_Voucher; Cash_Payment_Diff;


  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Receipt_Type').subscribe((res: string) => {
      this.Receipt_Type = res;
    });

    translate.get('Receipt_List').subscribe((res: string) => {
      this.Receipt_List = res;
    });
    this.model['title'] = this.Receipt_List;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('Cash_Receipt').subscribe((res: string) => {
      this.Cash_Receipt = res;
    });
    // this.receiptList['1']['receipt_ar'] = this.Cash_Receipt;

    translate.get('Payment_Voucher').subscribe((res: string) => {
      this.Payment_Voucher = res;
    });
    // this.receiptList['2']['receipt_ar'] = this.Payment_Voucher;

    translate.get('Cash').subscribe((res: string) => {
      this.Cash = res;
    });

    translate.get('Bank').subscribe((res: string) => {
      this.Bank = res;
    });

    translate.get('Visa').subscribe((res: string) => {
      this.Visa = res;
    });

    translate.get('All').subscribe((res: string) => {
      this.All = res;
    });
    // this.receiptList['0']['receipt_ar'] = this.All;
    
    translate.get('Search_Msg').subscribe((res: string) => {
      this.Search_Msg = res;
    });
    
    translate.get('Total_Cash_Receipt').subscribe((res: string) => {
      this.Total_Cash_Receipt = res;
    });

    translate.get('Total_Payment_Voucher').subscribe((res: string) => {
      this.Total_Payment_Voucher = res;
    });

    translate.get('Cash_Payment_Diff').subscribe((res: string) => {
      this.Cash_Payment_Diff = res;
    });
  }


  ngOnInit() {
    // this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.sample_add_auth = this.utils.getAuth(this.sample_menu_item_id, this.applicationConstants.ADD_AUTH);
    this.receipt_add_auth = this.utils.getAuth(this.receipt_menu_item_id, this.applicationConstants.ADD_AUTH);

    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
    // this.model['to_date'] = undefined;
    // this.model['from_date'] = undefined;
    this.model['from_date'] = new Date(this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-01");

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });

    let condition = '';
    if (this.applicationConstants.user_info['user_name'] != 'mas')
      condition += " AND `user`.`user_name` != 'mas'";

    query = "SELECT `user`.`user_id`, `employee`.`name`, `employee`.`name_en`, `user`.`user_name`, `employee`.`employee_no`" +
      " FROM `user`, `employee` WHERE `user`.`status` = '1' AND `employee`.`employee_no` = `user`.`employee_no`" + condition;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        
        this.users = data.data['list'];
        this.users.unshift({ 'user_name': 'all', 'name': 'الكل', 'name_en': 'All' });
      });
  }

  search() {
    this.dp = [];
    this.total1 = 0;
    this.total2 = 0;
    this.total3 = 0;

    if ((this.model['from_date'] == undefined || this.model['to_date'] == undefined) &&
      this.model['rec_no'] == '') {
      alert(this.Search_Msg);
      return;
    }

    let obj = { cmd: 'getReceiptList', 'receipt_type': this.model['receipt_type'] };

    if (this.model['rec_no'] != '') {
      obj['rec_no'] = this.model['rec_no'];

      if (this.branchList.length == 2) 
        obj['branch_id'] = this.branchList[1]['branch_id'];
      else {
        let branch_list = [];
        this.branchList.forEach(element => {
          if (element.branch_id != '0')
            branch_list.push({ 'branch_id': element.branch_id });
        });
        obj['branch_list'] = branch_list;
      }
    }
    else {
      if (this.model['from_date'] != undefined) {
        let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) +
          "-" + this.model['from_date'].getDate() + ' 00:00:00';
        obj['from_date'] = from_date;
      }

      if (this.model['to_date'] != undefined) {
        let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) +
          "-" + this.model['to_date'].getDate() + ' 23:59:59';
        obj['to_date'] = to_date;
      }

      if (this.model['payment_method'] != 'all') 
        obj['payment_method'] = this.model['payment_method'];

      if (this.model['user_name'] != 'all')
        obj['user_name'] = this.model['user_name'];

      if (this.model['branch_id'] == '0') {
        if (this.branchList.length == 2) 
          obj['branch_id'] = this.branchList[1]['branch_id'];
        else {
          let branch_list = [];
          this.branchList.forEach(element => {
            if (element.branch_id != '0')
              branch_list.push({ 'branch_id': element.branch_id });
          });
          obj['branch_list'] = branch_list;
        }
      }
      else 
        obj['branch_id'] = this.model['branch_id'];
    }

    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        // this.dp = data.data['list'];
        this.dp = data.status['msg'][0]['list'];
        this.total1 = data.status['msg'][0]['total1'];
        this.total2 = data.status['msg'][0]['total2'];
        this.total3 = data.status['msg'][0]['total3'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });

  }

  print(row = null) {

    if (row == null) {
      let html_data = '';
      let form = (document.getElementById('form1') as HTMLFormElement);

      html_data = '<table cellpadding="8" cellspacing="0">';
      html_data += '<tr><td width="33%"> ' + this.Receipt_Type + ': ';
      if (this.model['receipt_type'] != '') {
        this.receiptList.forEach(element => {
          if (element.receipt_type == this.model['receipt_type']) {
            html_data += element.receipt_name_ar;
            return;
          }
        });
      }
      html_data += '</td>';
      html_data += '<td width="33%"> ' + this.From_Date + ': ' + this.model['from_date'].getFullYear() + "-" +
        (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate() + '</td>';
      html_data += '<td width="33%"> ' + this.To_Date + ': ' + this.model['to_date'].getFullYear() + "-" +
        (this.model['to_date'].getMonth() + 1) + "-" + this.model['to_date'].getDate() + ' </td></tr>';

      html_data += '<tr>';
      if (this.model['receipt_type'] == "all") {
        html_data += '<td width="33%"> ' + this.Total_Cash_Receipt + ': ' + this.total1 + '</td>';
        html_data += '<td width="33%"> ' + this.Total_Payment_Voucher + ': ' + this.total2 + '</td>';
        html_data += '<td width="33%"> ' + this.Cash_Payment_Diff + ': ' + this.total3 + '</td>';
      }
      else if (this.model['receipt_type'] == "cash_receipt")
        html_data += '<td colspan="3"> ' + this.Total_Cash_Receipt + ': ' + this.total1 + '</td>';
      else if (this.model['receipt_type'] == "payment_voucher")
        html_data += '<td colspan="3"> ' + this.Total_Payment_Voucher + ': ' + this.total2 + '</td>';
      
      html_data += '</tr>';
      html_data += '</table>';

      let table = (document.getElementById('receipt_table2') as HTMLTableElement);
      html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
    }
    else
      window.open(this.applicationConstants.generatePDF + "?receipt_type=" + row.receipt_type + 
        "&receipt_no=" + row.receipt_no + "&lang=" + this.applicationConstants.user_lang, "_blank");
  }

  delReceipt(row) {
    if (confirm(this.Del_Msg)) {
      let values, obj;

      if (row.receipt_type == 'payment_voucher') {
        values = [{ 'table_name': 'payment_voucher', 'payment_voucher_no': row.payment_voucher_no }];
        values.push({ 'table_name': 'payment_voucher_acct', 'payment_voucher_no': row.payment_voucher_no });
        values.push({ 'table_name': 'payment_voucher_invoice', 'payment_voucher_no': row.payment_voucher_no });
      }
      else {
        values = [{ 'table_name': 'cash_receipt', 'cash_receipt_no': row.cash_receipt_no }];
        values.push({ 'table_name': 'cash_receipt_acct', 'cash_receipt_no': row.cash_receipt_no });
        values.push({ 'table_name': 'cash_receipt_invoice', 'cash_receipt_no': row.cash_receipt_no });
      }

      obj = { cmd: 'deleteRec', values: values };
      //console.log(values);
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {

            obj = { cmd: 'updatePaidInvoice', type: row.receipt_type };
            obj['no'] = (row.receipt_type == 'payment_voucher' ? row.payment_voucher_no : row.cash_receipt_no);

            this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();
                alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);

                if (data.status['type'] == 'success') 
                  this.search();
              });
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}


